import React, { useEffect, useState } from 'react'
import { Combobox } from 'react-widgets'

const FilterBar = ({
  onHandleFilter
}) => {
  const [listOfYear, setListOfYear] = useState()
  const [filterData, setFilterData] = useState({
    DateYear: new Date().getFullYear(),
    LiveListBy: 'Branch',
  })

  // LIST BY
  const listBy = [
    {value: 'Branch', name: 'Branch'},
    {value: 'Group', name: 'Group'}
  ]

  const handleSelectYear = (selected) => {
    setFilterData((prev) => ({
      ...prev,
      DateYear: selected,
    }));
  };

  const handleSelectListedBy = (selected) => {
    setFilterData((prev) => ({
      ...prev,
      LiveListBy: selected.value,
    }));
  };

  const handleFilter = () => {
    onHandleFilter(filterData)
  }

  // INITIATE YEAR
  useState(() => {
    let currentYear = new Date().getFullYear();

    let years = [currentYear];
    for (let idx = 0; idx < 4; idx++) years.unshift(--currentYear);
    setListOfYear(years);
  }, [])

  useEffect(() => {
    handleFilter()
  }, [])

  return (
    <div className='relative w-full'>
      <div className='filterbar-nohide'>
        <div className='filterbar__categories'>
          <div className='filterbar__category'>
            <label>List By</label>

            <Combobox
              className="list-box"
              data={ listBy }
              defaultValue={ filterData.LiveListBy }
              dataKey='value'
              textField='name'
              onSelect={ handleSelectListedBy }
              filter='contains'
            />
          </div>

          <div className='filterbar__category'>
            <label>Year</label>

            <Combobox
              className="list-box"
              data={ listOfYear }
              defaultValue={ filterData.DateYear }
              onSelect={ handleSelectYear }
              filter='contains'
            />
          </div>
        </div>

        <div className='filterbar__btn'>
          <button
            onClick={ handleFilter }
            type="button"
            className='btn-search'
          >
            Search
          </button>
        </div>
      </div>
    </div>
  )
}

export default FilterBar